module.exports = __webpack_public_path__ + "img/howto02.89878846.jpg";